import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import { formatPrice } from "../../util/format";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import {
    ItemsList,
    Item,
    ItemContainer,
    CollapseContainer,
    ItemContainerSecondary,
    Header,
    ContainerRow
} from "./styles";
import { DeliverySubtype, DeliveryType } from '../../util/deliveryType';
import { getExtractProductsCart } from '../../util/price';
import { PriceType } from '../../util/priceType';
import { productImageSrc, handleProductImageError } from '../../util/imageFallback';

const CollapseList = ({ items, customerHasFacilityProgram }) => {
    const [collapsed, setIsCollapsed] = useState(true);

    const [promotionOfProductsWithStock, setPromotionOfProductsWithStock] = useState([]);
    const [promotionOfProductsWithoutStock, setPromotionOfProductsWithoutStock] = useState([]);
    const [timeContigency, setTimeContigency] = useState(0);
    const [deliveryType, setDeliveryType] = useState("");
    const [priceDelivery, setPriceDelivery] = useState(undefined);


    useEffect(() => {
        loadPromotionsInScreen(items, customerHasFacilityProgram);
    }, [items, customerHasFacilityProgram]);

    function handleCollapse() {
        setIsCollapsed(!collapsed);
    }

    const loadInfoStore = (infoCheckout) => {
        if (infoCheckout) {
            setTimeContigency(infoCheckout.lojaSelecionada.tempo_contingencia_gam);
            setDeliveryType(infoCheckout.tipoEntrega);
            if (infoCheckout.tipoEntrega === DeliveryType.RECEBER_EM_CASA) {
                const priceDelivery = infoCheckout.subtipoEntrega === DeliverySubtype.EXPRESSA && infoCheckout.lojaSelecionada?.local_entrega?.permite_entrega_expressa ? infoCheckout.lojaSelecionada?.local_entrega?.custo_entrega_expressa : (infoCheckout.lojaSelecionada?.local_entrega?.custo_entrega ?? infoCheckout.custo_entrega)
                setPriceDelivery(priceDelivery);
            }
        }
    };

    const loadInfoCheckout = () => {
        const infoCheckout = localStorage.getItem("@ConexaoGAM:checkout");
        if (infoCheckout) {
            const { dadosEntrega } = JSON.parse(infoCheckout);
            return dadosEntrega;
        }
    };

    const getNextTimeStoreOpened = (infoCheckout) => {
        if (infoCheckout) {
            const initTime = infoCheckout.lojaSelecionada.lojaHorario?.hora_inicio;
            const endTime = infoCheckout.lojaSelecionada.lojaHorario?.hora_fim;
            const storeOpeningDate = infoCheckout.lojaSelecionada.lojaHorario?.data_disponibilidade;
            return `${storeOpeningDate} ${initTime.split(':').slice(0, 2).join(':')}-${endTime.split(':').slice(0, 2).join(':')}`;
        }
    }

    const transformStringToDate = (storeOpened) => {
        var [dayWeek, time] = storeOpened.split(" ")

        const dayWeekParameter = dayWeek.toLowerCase();
        var timeToAdd = 0;
        var currentDate = new Date();
        if (dayWeekParameter === "amanhã") {
            timeToAdd = 1;
        }
        else if (dayWeekParameter !== "hoje" && dayWeekParameter !== "amanhã") {
            var numberDayWeeek = {
                "domingo": 0,
                "segunda-feira": 1,
                "terça-feira": 2,
                "quarta-feira": 3,
                "quinta-feira": 4,
                "sexta-feira": 5,
                "sábado": 6
            }[dayWeekParameter];

            var currentDayWeek = currentDate.getDay();

            timeToAdd = ((numberDayWeeek) - currentDayWeek + 7) % 7;
        }

        currentDate.setDate(currentDate.getDate() + timeToAdd);

        var [hours, minutes] = time.split(':');
        currentDate.setHours(hours, minutes, 0, 0);
        return currentDate;
    }

    const loadPromotionsInScreen = (itens, customerHasFacilityProgram) => {
        const infoCheckout = loadInfoCheckout();
        loadInfoStore(infoCheckout);

        if (itens && itens.length > 0) {
            const nextTimeStoreOpened = getNextTimeStoreOpened(infoCheckout);
            let [date, timeRange] = nextTimeStoreOpened.split(' ');
            let [, endTime] = timeRange.split('-');
            const endTimeBeforeClose = new Date(`${date} ${endTime}`);

            const maxWaitingDate = new Date();
            maxWaitingDate.setHours(maxWaitingDate.getHours() + infoCheckout.lojaSelecionada.tempo_contingencia_gam);
            const canWaitStore = maxWaitingDate <= endTimeBeforeClose;

            const receiveInDifferentsDays = infoCheckout.receberEmDiasDiferentes;

            let treatedProducts = [];

            itens.forEach((product) => {
                if (product.estoques && product.estoques.length > 0) {
                    const stock = product.estoques.find(e => e.loja_id === infoCheckout.lojaSelecionada.id)
                    var quantityNeededInStoreStock = stock && stock.quantidade_associada > 0 ? (product.quantidade > stock.quantidade_associada ? stock.quantidade_associada : product.quantidade) : 0;
                    const quantityMissing = product.quantidade - quantityNeededInStoreStock;
                    const gamStock = stock ? (stock.quantidade - stock.quantidade_associada) : 0;
                    var quantityNeededInGamStock = gamStock > 0 ? (quantityMissing > gamStock ? gamStock : quantityMissing) : 0;

                    //predict whether the product will be in stock by the next store opening
                    if (canWaitStore) {
                        quantityNeededInStoreStock += quantityNeededInGamStock;
                        quantityNeededInGamStock = 0;
                    }

                    treatedProducts.push({ product: { ...product }, maxTotalFirstDelivery: quantityNeededInStoreStock, maxTotalSecondDelivery: quantityNeededInGamStock });
                }
            });

            splitProductsByContingency(treatedProducts, receiveInDifferentsDays, customerHasFacilityProgram);
        }
    };

    function splitProductsByContingency(productsStockInfo, receiveInDifferentsDays, hasFacilityProgram) {
        let promotionsWithStock = [];
        let promotionsWithoutStock = [];
        if (productsStockInfo.length > 0) {

            const productsStockSplit = productsStockInfo.map(productStockInfo => ({
                productId: productStockInfo.product.id,
                totalFirstDelivery: productStockInfo.maxTotalFirstDelivery ? productStockInfo.maxTotalFirstDelivery : 0,
                totalSecondDelivery: receiveInDifferentsDays ? productStockInfo.maxTotalSecondDelivery : productStockInfo.maxTotalSecondDelivery > 0 ? productStockInfo.maxTotalFirstDelivery + productStockInfo.maxTotalSecondDelivery : 0,
            }));

            const { promotions } = getExtractProductsCart(productsStockInfo.map(p => p.product), hasFacilityProgram)

            promotions.forEach(promotion => {
                const productStockInfoIndex = productsStockSplit.findIndex(p => p.productId === promotion.product.id);
                const promotionQuantity = promotion.promotionQuantity;
                const totalFirstDelivery = productsStockSplit[productStockInfoIndex].totalFirstDelivery;
                const totalSecondDelivery = productsStockSplit[productStockInfoIndex].totalSecondDelivery;
                let associadaQuantity = 0;
                let gamQuantity = 0;

                if (totalFirstDelivery > 0) {
                    associadaQuantity = promotionQuantity <= totalFirstDelivery ? promotionQuantity : totalFirstDelivery;
                }

                if (totalSecondDelivery > 0) {
                    gamQuantity = promotionQuantity > associadaQuantity ? promotionQuantity - associadaQuantity : 0;
                }

                if (associadaQuantity > 0) {
                    promotionsWithStock.push({ ...promotion, promotionQuantity: associadaQuantity, product: { ...promotion.product, quantidade: associadaQuantity } });
                }

                if (gamQuantity > 0) {
                    promotionsWithoutStock.push({ ...promotion, promotionQuantity: gamQuantity, product: { ...promotion.product, quantidade: gamQuantity } });
                }

                productsStockSplit[productStockInfoIndex].totalFirstDelivery -= associadaQuantity;
                productsStockSplit[productStockInfoIndex].totalSecondDelivery -= gamQuantity;
            });
        }

        setPromotionOfProductsWithStock(promotionsWithStock);
        setPromotionOfProductsWithoutStock(promotionsWithoutStock);
    }

    const PromotionTemplate = (promotion) => {
        return (
            <Item>
                <div className="content-area">
                    <img
                        src={productImageSrc(promotion.product)}
                        onError={handleProductImageError(promotion.product)}
                        alt={promotion.product.nome}
                    />
                    <div className="text-area">
                        <strong>{promotion.product.nome}</strong>
                        {promotion.type === PriceType.TAKEMOREPAYLESS && promotion.takeQuantity && promotion.payQuantity && (
                            <div className='row'>
                                <span className="quantity">Leve {promotion.takeQuantity} pague {promotion.payQuantity}</span>
                            </div>
                        )}
                        {(promotion.priceOf !== promotion.priceBy) && (
                            <div className='row'>
                                <span className="oldValue">De: {formatPrice(promotion.priceOf)}</span>
                            </div>
                        )}
                        <div className="row">
                            <span className="value">Por: {formatPrice(promotion.priceBy)}</span>
                            <span className="quantity">{promotion.promotionQuantity} {promotion.promotionQuantity > 1 ? "itens" : "item"}</span>
                        </div>
                    </div>
                </div>
            </Item>
        );
    }


    return (

        <ItemsList collapsed={collapsed} onClick={handleCollapse} style={{ cursor: "pointer" }}>
            <div>
                <Header style={{ paddingBottom: collapsed ? "0" : "20px" }}>
                    Meus produtos
                    <IoIosArrowDown style={{ display: collapsed ? "block" : "none", float: "right" }} />
                    <IoIosArrowUp style={{ display: collapsed ? "none" : "block", float: "right" }} />
                </Header>
                {!collapsed && (
                    <CollapseContainer>
                        {promotionOfProductsWithStock.length > 0 && (
                            <ItemContainer>
                                <ContainerRow>
                                    <h3>{deliveryType === DeliveryType.RECEBER_EM_CASA ? "Entrega" : "Retirada"} rápida</h3>
                                    {deliveryType === DeliveryType.RECEBER_EM_CASA && priceDelivery && (<p>Taxa de entrega {formatPrice(priceDelivery)}</p>)}
                                </ContainerRow>
                                <>
                                    {promotionOfProductsWithStock.map((item) => (
                                        <PromotionTemplate key={item.id} {...item} />
                                    ))}
                                </>
                            </ItemContainer>
                        )}
                        {promotionOfProductsWithoutStock.length > 0 && (
                            <ItemContainerSecondary>
                                <ContainerRow>
                                    <h3>{deliveryType === DeliveryType.RECEBER_EM_CASA ? "Entrega" : "Retirada"} em {timeContigency}h</h3>
                                    {deliveryType === DeliveryType.RECEBER_EM_CASA && priceDelivery && (<p>Taxa de entrega {formatPrice(priceDelivery)}</p>)}
                                </ContainerRow>

                                <>
                                    {promotionOfProductsWithoutStock.map((item) => (
                                        <PromotionTemplate key={item.id} {...item} />
                                    ))}
                                </>
                            </ItemContainerSecondary>
                        )}
                    </CollapseContainer>
                )}
            </div>
        </ItemsList>
    );
};

export default CollapseList;
